<template>
    <div class="row">
        <div class="col-12">
            <test 
                :schemeId="schemeId" 
                @change-scheme="schemeId = $event"
                @loading="loading = true"
                @done="processResult($event)"
                @result="processResult($event)"
            />

            <test-result v-model="result" :loading="loading"/>

            <logs ref="logs"/>
        </div>
    </div>
</template>

<script>

import Test from './Test.vue';
import Output from './Output.vue';
import Logs from './Logs.vue';

export default {
    name: 'operator-test-index',
    components: {
        Test,
        'TestResult': Output,
        Logs
    },
    methods: {
        processResult(result) {
            this.result = result;
            this.$refs.logs.load(this.schemeId);
            this.loading = false;
        }
    },
    data() {
        return {
             result: null,
             schemeId: null,
             loading: false
        };
    }
};
</script>

<style lang="scss" scoped>

</style>